import * as React from "react";
import { X } from "lucide-react";
import {
    Dialog,
    DialogContent,
} from "@/components/ui/dialog";

export interface ScreenshotRef {
    id: string;
    url: string;
    label?: string;
    capturedAt?: string;
}

interface Props {
    shot: ScreenshotRef | null;
    onClose: () => void;
}

/**
 * Full-resolution viewer for a single screenshot. Keeps it dead simple — the
 * Browse Resources panel handles list views; this is the "click a chip in
 * the chat to see what the AI was actually looking at" surface.
 */
export function ScreenshotLightbox({ shot, onClose }: Props): React.ReactNode {
    return (
        <Dialog open={shot != null} onOpenChange={(o) => !o && onClose()}>
            <DialogContent className="max-w-5xl p-0">
                {shot && (
                    <div className="relative">
                        <div className="flex items-center justify-between border-b px-4 py-2 text-xs">
                            <div className="flex items-center gap-3">
                                <span className="font-medium">{shot.label || "Screenshot"}</span>
                                <span className="font-mono text-muted-foreground">{shot.id}</span>
                                {shot.capturedAt && (
                                    <span className="text-muted-foreground">{new Date(shot.capturedAt).toLocaleString()}</span>
                                )}
                            </div>
                            <button onClick={onClose} className="text-muted-foreground hover:text-foreground" aria-label="Close">
                                <X className="h-4 w-4" />
                            </button>
                        </div>
                        <img
                            src={shot.url}
                            alt={shot.label || shot.id}
                            className="block w-full max-h-[80vh] object-contain"
                            data-testid="screenshot-lightbox-img"
                        />
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
}
